export default __webpack_public_path__ + "media/zurb/img/playground/balance-money-img-df7e49f6f3c5f5f106e604939765c608.png";